import React from 'react';
import './SozialShare.scss';

import {
  facebookIMG,
  twitterIMG,
  pinterestIMG,
  informationIMG,
} from './../overrides';

interface SozialShareProps {
  domainPrefix: string;
  productsId: number;
  canonicalLink: string;
}

export default class SozialShare extends React.Component<SozialShareProps> {
  getThisLink() {
    return encodeURIComponent(
      /*
      this.props.domainPrefix +
        "?main_page=product_info&products_id=" +
        this.props.productsId
        */
      this.props.canonicalLink,
    );
  }

  getThisTitle() {
    return encodeURIComponent('www.MOLUNA.de');
  }

  render() {
    // TODO: FIX LINKS
    return (
      <React.Fragment>
        <div id="SozialShare">
          {/* 
          <div className="button-atikel">
            <a
              className="artikel-bewerten"
              href={
                this.props.domainPrefix +
                "/index.php?main_page=product_reviews_write&products_id=" +
                this.props.productsId +
                "&number_of_uploads=0"
              }
              title="Artikel bewerten"
            >
              Artikel bewerten
            </a>
          </div>
          */}
          <div className="button-atikel simple">
            <a
              className="artikel-facebook-teilen"
              href={
                'https://www.facebook.com/sharer/sharer.php?u=' +
                this.getThisLink()
              }
              title="Artikel teilen"
              target="_blank"
            >
              <img src={facebookIMG} />
            </a>
          </div>
          {/*TODO: Generate share links */}
          <div className="button-atikel simple">
            <a
              className="artikel-twitter-teilen"
              href={
                'https://twitter.com/intent/tweet?' +
                'text=' +
                this.getThisTitle() +
                '&url=' +
                this.getThisLink()
              }
              title="Artikel teilen"
              target="_blank"
            >
              <img src={twitterIMG} />
            </a>
          </div>
          <div className="button-atikel simple">
            <a className="artikel-pinterest" href="#" title="Artikel teilen">
              <img src={pinterestIMG} />
            </a>
          </div>
          <div className="button-atikel simple">
            <a
              className="artikel-infos"
              href={this.props.domainPrefix + '/index.php?main_page=privacy'}
              title="Datenschutzbestimmungen"
            >
              <img src={informationIMG} />
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
